import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseService } from '../../../../../services/base.service';
import { TableColumnTypes } from '../../../../../model/table.model';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalService } from '../../../../../services/modal.service';
import { PageEvent } from '@angular/material/paginator';
import { PlannerComponent } from '../../../../../modals/planner/planner.component';
import {
  ADS_TYPES,
  BUNDLE_TYPES,
  DEFAULT_ERROR,
  ERROR_MESSAGES,
  activeTranslations,
  MODAL_TYPES,
} from '../../../../../enum/constants';
import moment from 'moment';
import { OlxAdvertService } from '../../../../../services/olx-advert.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '../../../../../services/notifications.service';
import { map } from 'rxjs';
import { DialogService } from '../../../../../services/dialog.service';
import { IAdsData, IOlxAdvert, IPayloadBundle } from './create-ads.interface';
import { IBundle } from './create-ads.interface';
import { TranslateService } from '@ngx-translate/core';

interface FormDateTime {
  type: FormControl;
  date: FormControl;
  time: FormControl;
  step: FormControl;
}

@Component({
  selector: 'app-create-ads',
  templateUrl: './create-ads.component.html',
  styleUrls: ['./create-ads.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateAdsComponent implements OnInit {
  public advertList: IOlxAdvert[] = [];
  public adsPrice: any = [];
  public channel_id!: string;
  public date: any;
  public isLoader: boolean = false;
  public today = new Date();
  public totalAmount: number = 0;
  currentIndex = 0;
  formPlanner!: FormGroup<FormDateTime>;
  public items: number[] = [];
  selectedBundles: any[] = [];
  selectedBundle: number | null = null;
  modalRes: any;
  public advertsWithExpTime: number[] = [];

  protected readonly TableColumnTypes = TableColumnTypes;

  displayedColumns: string[] = [
    'index',
    'ad_id',
    'title',
    'vas_list',
    'bundle_basic',
    'bundle_optimum',
    'bundle_premium',
  ];

  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  // 'up_list',
  constructor(
    public readonly baseService: BaseService,
    public readonly modalService: ModalService,
    private readonly olxAdvertService: OlxAdvertService,
    private readonly notificationService: NotificationService,
    private readonly dialogService: DialogService,
    private readonly translate: TranslateService,
  ) {}

  public onCloseSidebar(): void {
    this.close.emit('close');
  }

  ngOnInit() {
    this.advertList = this.payload?.selectionTable;
    this.channel_id = this.payload?.channel_id;
    this.isLoader = true;
    const ad_ids = this.advertList.map((res: IOlxAdvert) => res.id);
    const ad_ids_str = ad_ids.map((i: number) => i.toString());

    if (ad_ids.length > 1) {
      ad_ids.join(',');
      this.olxAdvertService.getAllAdvertising(this.channel_id, ad_ids_str).subscribe((res) => {
        this.adsPrice = res;
        this.isLoader = false;
      });
    } else {
      this.olxAdvertService.getOneAdvertising(this.channel_id, ad_ids_str).subscribe((res) => {
        this.adsPrice = res;
        if (this.adsPrice && this.advertList) {
          this.advertList.map((l: any) => {
            this.adsPrice.map((p: any) => {
              if (l.id === +p.ad_id) {
                return (p.ad_title = l.title);
              }
            });
          });
        }
        this.isLoader = false;
      });
    }
  }

  public setAllUpList(): void {}

  setDate(): void {
    this.modalService
      .openModal({
        title: 'ads_scheduler',
        translate: true,
        component: PlannerComponent,
        data: {
          modalType: MODAL_TYPES.ADS,
        },
      })
      .subscribe((res) => {
        if (res) {
          const dateToString = moment(res.x_data.date).format('DD/MM/YYYY');
          this.date = moment(`${dateToString} ${res.x_data.time}`, 'DD/MM/YYYY HH:mm');
          this.modalRes = res;
        }
      });
  }

  setCurrentIndex(event: any) {
    this.currentIndex = parseInt(event, 10) || 0;
  }

  onPageChange(event: PageEvent): void {
    this.currentIndex = event.pageIndex;
    this.setCurrentIndex(this.currentIndex);
  }

  nextSlide(): void {
    if (this.currentIndex < this.advertList.length - 1) {
      this.currentIndex++;
    }
  }

  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  getSliderTransform(): string {
    return `translateX(-${this.currentIndex * 100}%)`;
  }

  addPrice(event: any, elem: any, key: string, value: string): void {
    elem[key] = event ? value : null;
    this.getPrice();
    this.updateSelectedBundles();
    this.filterAppliedAds();
  }

  updateSelectedBundles(): void {
    this.selectedBundles = this.adsPrice.filter((v: any) => v.bundle || v.vas);
  }

  getPrice() {
    let price = 0;
    this.adsPrice.forEach((v: any) => {
      const bundle = v.bundles.find((a: any) => a.product_id === v.bundle);
      const vas = v.vas_list.find((a: any) => a.product_id === v.vas);
      if (bundle) {
        price += bundle.pricing.regular.raw;
      }
      if (vas) {
        price += vas.pricing.regular.raw;
      }
    });
    this.totalAmount = price ? price / 100 : price;
  }

  // This function filtered already applied ads
  public filterAppliedAds() {
    this.advertsWithExpTime = this.selectedBundles
      .filter((adv: IAdsData) =>
        adv.bundles.some((bundle: IBundle) => !bundle.enabled && adv.bundle === bundle.product_id),
      )
      .map((res: IAdsData) => res.ad_id);
  }

  public onPay(): void {
    this.filterAppliedAds();

    const text =
      this.advertsWithExpTime.length > 0
        ? this.translate.instant('plan_applied_ads', { advertsWithExpTime: this.advertsWithExpTime })
        : 'dialogs.pay_ad';

    const dialogRef = this.dialogService.openConfirm({
      isTranslate: this.advertsWithExpTime.length > 0,
      text: text,
      price: this.totalAmount,
    });

    dialogRef.subscribe((result) => {
      if (result) {
        const bundles: IPayloadBundle[] = [];
        this.adsPrice.forEach((v: any) => {
          const advert = this.advertList.find((a: IOlxAdvert) => a.id === v.ad_id);
          if (v.bundle) {
            bundles.push({
              advert_id: v.ad_id,
              title: v.ad_title,
              code: v.bundle,
              advert: advert || this.advertList[0],
            });
          }

          if (v.vas) {
            bundles.push({
              advert_id: v.ad_id,
              title: v.ad_title,
              code: v.vas,
              advert: advert || this.advertList[0],
            });
          }
        });

        if (this.date) {
          const payload = {
            selectedBundle: bundles,
            date: this.date,
            name: this.modalRes.name,
            status: this.modalRes.x_data.status,
          };
          this.olxAdvertService.payAds(payload, this.channel_id).subscribe((res) => {
            if (res) {
              this.close.emit();
              this.notificationService.showSuccess(
                '',
                activeTranslations.notifications_texts.success.successfully_planned,
              );
            } else {
              this.close.emit();
              this.notificationService.showError(
                '',
                activeTranslations.notifications_texts.error.error_while_planner,
              );
            }
          });
        } else {
          const payload = {
            selectedBundle: bundles,
          };
          this.olxAdvertService.payAds(payload, this.channel_id).subscribe((res) => {
            this.close.emit();
          });
        }
      }
    });
  }

  cancelPlanner() {
    this.date = null;
  }

  isAnyBundleSelected(): boolean {
    return Array.isArray(this.adsPrice) && this.adsPrice.some((element: any) => !!element.bundle || !!element.vas);
  }

  protected readonly ADS_TYPES = ADS_TYPES;
  protected readonly BUNDLE_TYPES = BUNDLE_TYPES;
}
